import React from "react";
import DataGrid from "./DataGrid/DataGrid.tsx";

interface DocumentLogDataGridProps {
  logs: {
    date: string;
    valior: string;
    agent: string;
    action: string;
    user: string;
  }[];
  isLoading: boolean;
}

const DocumentSearchDataGrid: React.FC<DocumentLogDataGridProps> = ({
  logs,
  isLoading,
}) => {
  const columns = [
    {
      name: "date",
      header: "Дата",
      minWidth: 100,
      type: "string",
    },
    {
      name: "valior",
      header: "Вальор",
      minWidth: 150,
      type: "string",
    },
    {
      name: "agent",
      header: "Агент",
      minWidth: 150,
      type: "string",
    },
    {
      name: "action",
      header: "Действие",
      minWidth: 100,
      type: "string",
    },
    {
      name: "user",
      header: "Потребител",
      minWidth: 100,
      type: "string",
    },
  ];

  return (
    <DataGrid
      columns={columns}
      dataSource={logs}
      isLoading={isLoading}
      gridTitle="Резултати от търсенето"
      idProperty="Number"
      csvFilename="logs.csv"
      icon="fa-kit fa-search"
      editable={false}
    />
  );
};

export default DocumentSearchDataGrid;
